export const SUB_CATEGORIES_RESET_STATE = 'SUB_CATEGORIES_RESET_STATE';
export const SUB_CATEGORIES_CURRENT_ITEM = 'SUB_CATEGORIES_CURRENT_ITEM';

export const SUB_CATEGORIES_REQUEST_LOADING = 'SUB_CATEGORIES_REQUEST_LOADING';
export const SUB_CATEGORIES_REQUEST_SUCCESS = 'SUB_CATEGORIES_REQUEST_SUCCESS';
export const SUB_CATEGORIES_REQUEST_FAILED = 'SUB_CATEGORIES_REQUEST_FAILED';

export const SUB_CATEGORIES_CURRENT_ACTION = 'SUB_CATEGORIES_CURRENT_ACTION';
export const SUB_CATEGORIES_RESET_ACTION = 'SUB_CATEGORIES_RESET_ACTION';